export default __webpack_public_path__ + "static/media/Gloves of the Ecliptic.de1cfe2b.jpg";